module.exports = __webpack_public_path__ + "static/media/document-single.f65a1789.svg";